// src/components/HeaderOnlyLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";
import AppHeader from "./Header";

/**
 * サイドバーなし・ヘッダーのみの共通レイアウト。
 * hasPatientContext=false で患者文脈UIを非表示にしておく。
 * 中身（背景色や余白）は各ページ側に任せる。
 */
export default function HeaderOnlyLayout() {
  return (
    <>
      <AppHeader hasPatientContext={false} />
      <Outlet />
    </>
  );
}
